import PercentIcon from "@mui/icons-material/Percent";
import { type FC } from "react";

import { FilterRangeSlider } from "~/components/UI/FilterRangeSlider";
import { SubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard";
import { useSubscriptionGuard } from "~/feature/subscription/components/SubscriptionGuard/useSubscriptionGuard";
import { FeatureKey } from "~/types/subscription";
import { formatNumber, formatPercentageValue } from "~/utils/formatValue";

import { useProbabilityFilter } from "./useProbabilityFilter";

const ProbabilityDialogTitle = "Change Range (0-100%)";

const formatPrice = (value: number) =>
  formatNumber(value, { maximumFractionDigits: 2 });

const formatPercentage = (value: number) => formatPercentageValue(value * 100);

const getProbabilityHelpText = ([min, max]: [number, number]) => {
  if (min === max) {
    return `Exactly ${formatPercentage(min)} chance\n(Price: ${formatPrice(min)})`;
  }

  return `Between ${formatPercentage(min)} and ${formatPercentage(max)} chance\n(Price: ${formatPrice(min)} - ${formatPrice(max)})`;
};

export const ProbabilityFilter: FC = () => {
  const { initialValue, onChangeProbabilityFilter } = useProbabilityFilter();
  const { isLocked } = useSubscriptionGuard(FeatureKey.PROBABILITY_SLIDER);

  return (
    <SubscriptionGuard featureKey={FeatureKey.PROBABILITY_SLIDER}>
      <FilterRangeSlider
        label="Probability"
        icon={<PercentIcon fontSize="inherit" />}
        locked={isLocked}
        initialValue={initialValue}
        onChange={onChangeProbabilityFilter}
        dialogTitle={ProbabilityDialogTitle}
        getHelpText={getProbabilityHelpText}
        min={0}
        max={1}
        step={0.01}
      />
    </SubscriptionGuard>
  );
};
